'use strict';

import angular from 'angular';
import Storyboard from './storyboard.controller';

export default angular.module('bfastCaptureManagerApp.application.storyboard', [])
  .controller('AppStoryboardController', Storyboard)
  .name;



// WEBPACK FOOTER //
// ./client/app/application/storyboard/index.js